export const VerifiedIcon = () => (
  <svg
    width="110"
    height="110"
    viewBox="0 0 110 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.9309 65.7263C52.9309 65.7263 50.7984 74.2564 42.2683 74.2564C33.7382 74.2564 31.6057 65.7263 31.6057 65.7263C31.6057 65.7263 8.14795 69.9615 8.14795 93.4491H76.3887C76.3887 70.0447 52.9309 65.7263 52.9309 65.7263Z"
      fill="#EE4D2D"
    />
    <path
      d="M42.2681 78.5217C31.6055 78.5217 31.6055 65.7265 31.6055 65.7265V52.9314H52.9307V65.7265C52.9307 65.7265 52.9307 78.5217 42.2681 78.5217Z"
      fill="#FFC645"
    />
    <path
      d="M65.7256 41.7358C65.7256 44.0922 63.817 46.0008 61.4605 46.0008C59.1041 46.0008 57.1955 44.0922 57.1955 41.7358C57.1955 39.3793 59.1041 37.4707 61.4605 37.4707C63.817 37.4707 65.7256 39.3793 65.7256 41.7358ZM27.3402 41.7358C27.3402 44.0922 25.4315 46.0008 23.0751 46.0008C20.7187 46.0008 18.8101 44.0922 18.8101 41.7358C18.8101 39.3793 20.7187 37.4707 23.0751 37.4707C25.4315 37.4707 27.3402 39.3793 27.3402 41.7358Z"
      fill="#FFC645"
    />
    <path
      d="M61.4611 27.3413C61.4611 11.0595 23.0757 16.7405 23.0757 27.3413V42.2689C23.0757 52.8697 31.6676 61.4616 42.2684 61.4616C52.8692 61.4616 61.4611 52.8697 61.4611 42.2689V27.3413Z"
      fill="#FFD16A"
    />
    <path
      d="M42.2686 8.14819C29.3135 8.14819 20.9434 18.6509 20.9434 31.6059V36.017C20.9434 36.3087 21.0708 36.586 21.2922 36.7759L23.5572 38.7193C24.2058 39.2758 25.2084 38.815 25.2084 37.9604V30.2866C25.2084 29.8129 25.5407 29.4042 26.0045 29.3076L50.4054 24.2241C50.6578 24.1715 50.9207 24.2184 51.1394 24.355L58.8588 29.1797C59.1512 29.3624 59.3288 29.6829 59.3288 30.0277V37.9397C59.3288 38.7977 60.3382 39.2573 60.9854 38.694L63.2504 36.7223C63.4686 36.5323 63.5938 36.2573 63.5938 35.968V31.6059C63.5938 23.1551 61.4481 14.7766 51.283 12.5151C50.9813 12.448 50.7178 12.2515 50.5796 11.975L48.9426 8.70098C48.7732 8.3622 48.4269 8.14819 48.0481 8.14819H42.2686Z"
      fill="#202325"
    />
    <path
      d="M48.6657 40.1364C48.6657 41.3136 49.621 42.269 50.7982 42.269C51.9753 42.269 52.9307 41.3136 52.9307 40.1364C52.9307 38.9593 51.9753 38.0039 50.7982 38.0039C49.621 38.0039 48.6657 38.9593 48.6657 40.1364ZM31.6055 40.1364C31.6055 41.3136 32.5608 42.269 33.738 42.269C34.9151 42.269 35.8705 41.3136 35.8705 40.1364C35.8705 38.9593 34.9151 38.0039 33.738 38.0039C32.5608 38.0039 31.6055 38.9593 31.6055 40.1364Z"
      fill="#202325"
    />
    <path
      d="M42.2682 78.5215C52.9308 78.5215 56.652 70.1406 57.0913 66.9461C54.624 66.0419 52.9308 65.7263 52.9308 65.7263C52.9308 65.7263 50.7983 74.2564 42.2682 74.2564C33.7381 74.2564 31.6056 65.7263 31.6056 65.7263C31.6056 65.7263 29.9123 66.0377 27.4429 66.9333C27.8779 70.1214 31.6056 78.5215 42.2682 78.5215Z"
      fill="#FF8066"
    />
    <path
      d="M83.5184 65.1853L86.6658 67.6953L90.5343 66.5808L92.4816 70.1043L96.482 70.555L96.9328 74.5554L100.456 76.5028L99.3417 80.3712L101.852 83.5186L99.3417 86.6661L100.456 90.5345L96.9328 92.4818L96.482 96.4823L92.4816 96.933L90.5343 100.456L86.6658 99.342L83.5184 101.852L80.3709 99.342L76.5025 100.456L74.5552 96.933L70.5548 96.4823L70.104 92.4818L66.5806 90.5345L67.6951 86.6661L65.1851 83.5186L67.6951 80.3712L66.5806 76.5028L70.104 74.5554L70.5548 70.555L74.5552 70.1043L76.5025 66.5808L80.3709 67.6953L83.5184 65.1853Z"
      fill="#FFC645"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.6849 79.1249L83.0576 89.6815C82.689 90.0857 82.1728 90.3241 81.6261 90.3425C81.0794 90.361 80.5483 90.158 80.1533 89.7796L74.3516 84.2222L77.1602 81.2901L81.4595 85.4083L89.6848 76.3889L92.6849 79.1249Z"
      fill="white"
    />
  </svg>
);
